import {Component, Inject} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

export const MAX_COMMENT_LENGTH = 255;

@Component({
    templateUrl: './delete-dialog.component.html',
    standalone: false,
})
export class DeleteDialogComponent {
    form: FormGroup<DeleteIncidentForm>;
    maxCommentLength = MAX_COMMENT_LENGTH;
    showReason: boolean;

    constructor(
        @Inject(MAT_DIALOG_DATA) public dialogData: DeleteDialogData,
        public dialogRef: MatDialogRef<DeleteDialogComponent>,
        private formBuilder: FormBuilder,
    ) {
        this.showReason = !!this.dialogData.showReason;

        this.form = this.formBuilder.group<DeleteIncidentForm>({
            comment: this.formBuilder.control<string>('',
                {nonNullable: true, validators: [Validators.required]}),
            reason: this.formBuilder.control<string | null>(null),
        });
        if (this.showReason) {
            this.form.controls.reason.addValidators([Validators.required]);
        } else {
            this.form.controls.reason.clearValidators();
            this.form.controls.reason.setValue(null);
        }
        this.form.controls.reason.updateValueAndValidity({emitEvent: false});
    }

}

export interface DeleteDialogData {
    id: string;
    title: string;
    subtitle: string;
    showReason?: boolean;
    reasonFilter?: string[];
}

interface DeleteIncidentForm {
    comment: FormControl<string>;
    reason: FormControl<string | null>;
}
